/**
 * Dynamic import utilities for code splitting
 * This helps manage dynamic imports consistently across the application
 */

// Reading Services
export const importReadingService = () => import('@services/reading/readingService');
export const importReadingAnalyticsService = () => import('@services/reading/readingAnalyticsService');
export const importReadingSessionService = () => import('@services/reading/readingSessionService');

// Large Libraries (for lazy loading)
export const importBabylonJS = () => import('@babylonjs/core');
export const importH5P = () => import('@lumieducation/h5p-react');

// Utility function to handle dynamic imports with error handling
export const safeDynamicImport = async <T>(
    importFn: () => Promise<T>,
    fallback?: T
): Promise<T> => {
    try {
        return await importFn();
    } catch (error) {
        console.error('Dynamic import failed:', error);
        if (fallback) {
            return fallback;
        }
        throw error;
    }
};

// Preload utilities for critical paths
export const preloadReadingServices = () => {
    // Preload reading services when user navigates to reading section
    importReadingService();
    importReadingAnalyticsService();
    importReadingSessionService();
}; 